import { Typography, Card, Row, Col, Statistic } from 'antd'
import {
  UserOutlined,
  FileTextOutlined,
  BarChartOutlined,
} from '@ant-design/icons'

const { Title } = Typography

function DashboardPage() {
  return (
    <div>
      <Title level={2}>Дашборд</Title>

      <Row gutter={[16, 16]} style={{ marginTop: 24 }}>
        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="Сотрудники"
              value={0}
              prefix={<UserOutlined />}
              valueStyle={{ color: '#3f8600' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="Справочники"
              value={0}
              prefix={<FileTextOutlined />}
              valueStyle={{ color: '#1890ff' }}
            />
          </Card>
        </Col>

        <Col xs={24} sm={12} lg={8}>
          <Card>
            <Statistic
              title="Отчеты"
              value={0}
              prefix={<BarChartOutlined />}
              valueStyle={{ color: '#cf1322' }}
            />
          </Card>
        </Col>
      </Row>

      <Card style={{ marginTop: 24 }}>
        <Title level={4}>Добро пожаловать в Медцифра.рф</Title>
        <p>
          Это стартовая страница дашборда. Здесь будет отображаться основная
          информация и быстрый доступ к функциям платформы.
        </p>
      </Card>
    </div>
  )
}

export default DashboardPage
